module.exports = __webpack_public_path__ + "static/logo-dark-2x-5fef9f0b1642f2a44d8924812856799e.png";